import { getHasMetadataFilterForEqlField } from '@modules/quantify/utils';
import { MessageRounded } from '@mui/icons-material';
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  MenuItem,
} from '@mui/material';
import { TimeUnit } from 'generated/graphql';
import { useGetEQLExpression } from 'v2/core/repository/edge-server/eql/useGetEQLExpression';
import { ExpressionType } from 'v2/core/repository/eql/types';
import { combineWhereClauses } from 'v2/core/services/queryBuilder/combineWhereClauses';
import { OperationType } from 'v2/core/services/queryBuilder/whereClause';
import { useGetUser } from 'v2/core/services/user';
import { shallow } from 'zustand/shallow';
import { trackQuickFiltersEvents } from '../helpers/trackQuickFiltersEvents';
import { useChartTooltipStore } from '../hooks';

interface ViewFeedbackProps {
  isMenuItem?: boolean;
}

export function ViewFeedback({ isMenuItem }: ViewFeedbackProps) {
  const {
    tenant: { id: tenantID },
  } = useGetUser();
  const {
    dateRange,
    baseWhereClause,
    dataPointWhereClause,
    setData,
    measuredAsCriteria,
  } = useChartTooltipStore(
    ({
      baseWhereClause,
      dataPointWhereClause,
      dateRange,
      setData,
      measuredAsCriteria,
    }) => ({
      baseWhereClause,
      dataPointWhereClause,
      dateRange,
      setData,
      measuredAsCriteria,
    }),
    shallow,
  );

  const measuredAsCriteriaWhereClause =
    getHasMetadataFilterForEqlField(measuredAsCriteria);

  const unionOfBaseAndDataPointWhereClause = combineWhereClauses(
    baseWhereClause,
    dataPointWhereClause,
    OperationType.AND,
  );

  const whereClause = measuredAsCriteriaWhereClause
    ? combineWhereClauses(
        unionOfBaseAndDataPointWhereClause,
        measuredAsCriteriaWhereClause,
        OperationType.AND,
      )
    : unionOfBaseAndDataPointWhereClause;

  const eqlExpression = useGetEQLExpression({
    tenantID,
    eqlProps: {
      expressionType: ExpressionType.Aggregates,
      dateRange,
      whereClause,
    },
  });

  const showFeedbackDrawer = () => {
    const feedbackQueryContainer = {
      AggregatePeriod: TimeUnit.Week,
      DateRange: dateRange,
      WhereClause: whereClause,
    };

    setData({
      shouldOpenFeedbackDrawer: true,
      feedbackQueryContainer,
    });
    trackQuickFiltersEvents({
      eventName: 'Quick Filter View Feedback',
      eqlExpression: eqlExpression.eql,
      triggerType: 'Chart',
    });
  };

  if (isMenuItem) {
    return (
      <MenuItem onClick={showFeedbackDrawer}>
        <ListItemIcon>
          <MessageRounded
            sx={{
              color: 'text.disabled',
            }}
          />
        </ListItemIcon>
        <ListItemText primary="View feedback" />
      </MenuItem>
    );
  }

  return (
    <ListItem disablePadding onClick={showFeedbackDrawer}>
      <ListItemButton>
        <ListItemIcon>
          <MessageRounded
            sx={{
              color: 'text.disabled',
            }}
          />
        </ListItemIcon>
        <ListItemText primary="View feedback" />
      </ListItemButton>
    </ListItem>
  );
}
